module.exports = {"routes":{"contact":["/contact"],"about":["/a-propos"],"courses":["/formations"],"courses_details":["/formations/:slug"],"page_details":["/page/:slug"],"page_details_liens":["/page/liens"],"page_details_conditions":["/page/conditions-utilisation"],"news":["/actualites"],"news_details":["/actualites/:slug"]}}


//////////////////
// WEBPACK FOOTER
// ./src/app/router/translations_routes.json
// module id = 177
// module chunks = 0